import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'fi-day-picker',
    templateUrl: './day-picker.component.html',
    styleUrls: ['./day-picker.component.scss'],
    standalone: false,
})
export class DayPickerComponent {
    @Input() day: number;
    @Input() month: number;
    @Input() year: number;
    @Input() unfocused: boolean;

    shownYear: number;
    shownMonth: number;

    days: ((number|undefined)[])[] = [];
    now = new Date();

    @Output() onDateSelected = new EventEmitter<Date>();

    constructor() {

    }

    incrementMonth(): void {
        const day = new Date(this.shownYear, this.shownMonth, 1, 0, 0, 0, 0);
        day.setMonth(day.getMonth() + 1);
        this.shownYear = day.getFullYear();
        this.shownMonth = day.getMonth();

        this.refresh();
    }

    decrementMonth(): void {
        const day = new Date(this.shownYear, this.shownMonth, 1, 0, 0, 0, 0);
        day.setMonth(day.getMonth() - 1);
        this.shownYear = day.getFullYear();
        this.shownMonth = day.getMonth();

        this.refresh();
    }

    refresh(): void {
        const day = new Date(this.shownYear, this.shownMonth, 1, 0, 0, 0, 0);
        const firstDayOfNextMonth = new Date(day);
        firstDayOfNextMonth.setMonth(firstDayOfNextMonth.getMonth() + 1);
        this.now = new Date();
        this.days = [[]];
        let lastDay = this.days[0];
        const offset = (day.getDay() + 6) % 7;

        for (let i = 0; i < offset; ++i) {
            lastDay.push(undefined);
        }

        while (day < firstDayOfNextMonth) {
            if (lastDay.length > 6) {
                lastDay = [];
                this.days.push(lastDay);
            }

            lastDay.push(day.getDate());
            day.setDate(day.getDate() + 1);
        }

        while (this.days.length < 6) {
            this.days.push([undefined]);
        }

        this.days.forEach(x => x.length = 7);
    }

    selectDay(day: number): void {
        this.onDateSelected.emit(new Date(this.shownYear, this.shownMonth, day, 0, 0, 0, 0));
    }
}
